import { shiftLabel, shiftNumberForHour } from "../shift";

export function getCorrectShift(hour) {
  // Shift boundaries all fall on the hour, so the minute is not needed.
  return shiftLabel(shiftNumberForHour(parseInt(hour, 10)));
}

export function formatTime(hourStr, minuteStr) {
  // Check if hour and minute are valid numbers
  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  // Validate hour and minute
  if (isNaN(hour) || isNaN(minute)) {
    return "error";
  }
  if (hour < 0 || hour > 23) {
    return "error";
  }
  if (minute < 0 || minute > 59) {
    return "error";
  }

  // Format hour and minute to always have two digits
  const formattedHour = String(hour).padStart(2, "0");
  const formattedMinute = String(minute).padStart(2, "0");

  return `${formattedHour}:${formattedMinute}`;
}
